module.exports = __webpack_public_path__ + "img/circasia.d5748d1a.svg";